export enum SharedComponentsDeletionModalTestIds {
  CANCEL_BUTTON = 'shared-components-deletion-modal-cancel-button',
  DELETE_BUTTON = 'shared-components-deletion-modal-delete-button',
  MODAL = 'shared-components-deletion-modal',
  TEXT = 'shared-components-deletion-modal-text-button',
  TITLE = 'shared-components-deletion-modal-title',
}
